import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class NotificacionesService {
  endpoint = environment.apiUrl + 'Auditoria/INotify/';
// endpoint = 'https://localhost:64978/' + 'INotify/'; //aqui A206

  constructor(private http: HttpClient) { }

  getNotificacion(values: any): Observable<any> {
    return this.http.post<any>(this.endpoint, JSON.stringify(values));
  }

  leerNotificacion(values: any): Observable<any> {
    return this.http.put<any>(
      this.endpoint,
      JSON.stringify(values)
    );
  }

}
